import React, { useState, useCallback, useContext, useMemo } from 'react';
import useLocations from '@ubeya/shared/hooks/account/useLocations';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

// Keeps the employees whose profile "Preferred areas" include one of the picked areas. Only areas
// (sub-locations) are offered - a preferred area is always a sub-location.
const PreferredAreaFilter = ({ defaultValue, handleClose, onApply, onChange, search, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const { locationsOptions } = useLocations();

  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const areasOptions = useMemo(() => locationsOptions.filter(({ isSubLocation }) => isSubLocation), [locationsOptions]);

  const filteredOptions = useMemo(
    () =>
      search
        ? areasOptions.filter(
            ({ label }) =>
              t('preferredArea').toLowerCase().includes(search.toLowerCase()) ||
              (label && label.toLowerCase().includes(search.toLowerCase()))
          )
        : areasOptions,
    [areasOptions, search, t]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('preferredArea')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            useTextWithTooltip
            name={`preferred-area-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default PreferredAreaFilter;
